var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:{
		container: true,
		clickable: _vm.props.clickable,
		active: _vm.props.active,
	},on:{"click":_vm.listeners.click}},[(_vm.props.item.type === 'category')?_c('CategoryItem',{attrs:{"item":_vm.props.item}}):(_vm.props.item.type === 'subcategory')?_c('SubcategoryItem',{attrs:{"item":_vm.props.item}}):(_vm.props.item.type === 'node')?_c('NodeItem',{attrs:{"nodeType":_vm.props.item.properties.nodeType,"bordered":!_vm.props.lastNode},on:{"dragstart":_vm.listeners.dragstart,"dragend":_vm.listeners.dragend}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }